<template>
  <div style="margin-top: 10px;">
    <div class="middle" style="background-color: rgb(228, 228, 228);line-height: 35px;">
      <div class="pop" style="background-color: rgb(228, 228, 228);margin-left:10px;">
        <span style="text-align:left;">抄送人</span>
      </div>
    </div>
    <div class="load">
      <ul style="margin-bottom:0px;    min-height: 60px;">
        <li style="margin-top: 2px;">
          <ul>
            <li style="float:left;margin:5px 5px 5px 5px;position:relative;text-align:left;"
                v-for="user in copyUserModel.selectList" :key="user.id">
              <div :title="user.userName">
                <div>
                  <img style="width:43px;height:43px;" :src="user.picture || sessionUtil.getDefaultAvatar()" alt=""></div>
                <div style="text-align:center; font-size: 10px;">
                  <el-tooltip class="item" effect="dark" :content="user.userName" placement="bottom">
                    <span>{{user.userName.length>3?user.userName.substring(user.userName.length-3,user.userName.length):user.userName}}</span>
                  </el-tooltip>
                </div>
              </div>
              <i @click="removeCopyUser(user,$event)" v-if="showCopyUserDelete" class="changeDelete"
                 style="position:absolute;top:-6px;left:-5px;background:#f00;width:20px;height:20px;font-size:14px;line-height:20px;border-radius:50%;color:#fff">&nbsp;X</i>
            </li>
            <li v-if="ifSelCopy" style="float:left;margin:5px 0px 17px 3px;position:relative;text-align:left;">
              <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc" @click="addCopyUser()" aria-hidden="true">
                <use xlink:href="#icon-tianjiarenyuan"></use>
              </svg>
              <!-- <img style="width:45px;height:45px;" @click="addCopyUser()" src="../../assets/addPeople1.png"> -->
            </li>
            <li v-if="ifSelCopy" style="float:left;margin:5px 5px 17px 5px;position:relative;text-align:left;">
              <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc" @click="delCopyUser()" aria-hidden="true">
                <use xlink:href="#icon-shanchulianxiren"></use>
              </svg>
              <!-- <img style="width:45px;height:45px;" @click="delCopyUser()" src="../../assets/removePeople1.png"> -->
            </li>
          </ul>
        </li>

      </ul>
    </div>
    <div style="text-align: right;padding: 5px 0px;">
      <el-button style=""  type="info" size="mini" @click="cancel()" >取消</el-button>
      <el-button  type="primary" size="mini" @click="ok()" >确定</el-button>
    </div>
    <selectMember :selectMemberModels='copyUserModel' ref="selectCopyUser"></selectMember>
  </div>
</template>

<script>
import selectMember from '@/common/select-user/select-user.vue'
import {mixin} from './index.js'
export default {
  name: 'copy-form',
  mixins: [mixin],
  components: {
    selectMember
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/wf/copy-form/index.vue